import styled from 'styled-components/macro'
import GoldenTexture from 'assets/golden-bg.webp'
import { theme } from 'styles/theme'

export const ShareContainer = styled.div<{ $spacing: 'small' | 'large' }>`
  display: flex;
  justify-content: center;
  gap: ${props => (props.$spacing === 'small' ? '0.7rem' : '1.5rem')};

  a {
    color: inherit;

    &:hover,
    &:focus-visible {
      color: #d4b86b;
    }
  }
`

export const TexturedText = styled.p`
  margin: 0.2em auto 0;
  font-size: 1.6rem;
  width: max-content;
  color: transparent;
  background: url(${GoldenTexture}) center center / cover no-repeat;
  -webkit-background-clip: text;
  background-clip: text;

  svg {
    margin-bottom: -0.2em;
    font-size: 1.5rem;
    color: ${theme.colors.textDark};
  }
`
